export default {
  title: '承运人管理',

  // 标签页
  tabs: {
    shipping: '船公司',
    airline: '航空公司',
    railway: '铁路公司',
    express: '快递运营商'
  },

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    shippingPlaceholder: '公司名称、公司代码、SCAC CODE',
    airlinePlaceholder: '公司名称、中英文别名、IATA二字码、ICAO三字码',
    railwayPlaceholder: '公司名称、公司代码、国家、省/州',
    expressPlaceholder: '运营商名称、运营商编码、客户账号',
    status: '状态',
    statusPlaceholder: '选择状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    addShipping: '新增船公司',
    addAirline: '新增航空公司',
    addRailway: '新增铁路公司',
    addExpress: '新增快递运营商',
    editExpress: '编辑快递运营商',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    enableItem: '启用',
    disableItem: '禁用',
    ediSetting: 'EDI设置',
    weightTierSetting: '设置重量段',
    densityGradeSetting: '密度等级',
    batchWeightTier: '批量设置重量段',
    batchDensityGrade: '批量设置密度等级',
    recordsCount: '共 {count} 条记录'
  },

  // 快递运营商
  express: {
    accountNos: '客户账号',
    accountNosPlaceholder: '多个账号以英文逗号分隔',
    serviceTypes: '服务类型',
    serviceTypePlaceholder: '请选择服务类型',
    serviceTypeLoadingPlaceholder: '服务类型加载中...',
    remark: '备注',
    remarkPlaceholder: '请输入备注',
    saveSuccess: '快递运营商保存成功',
    carrierCodeRequired: '请输入运营商编码',
    carrierCodeAutoPlaceholder: '保存后自动生成',
    nameCnRequired: '请输入运营商名称（中文）',
    serviceTypeRequired: '请选择服务类型',
    weightTierTitle: '快递重量段配置 - {name}',
    weightTierTip: '重量段按服务类型分别维护，同一服务类型内必须连续且不重叠。',
    weightTierServiceTypeRequired: '请选择重量段服务类型',
    weightTierSaveSuccess: '快递重量段配置保存成功'
  },

  // 快递服务类型
  expressServiceType: {
    express: '特快',
    DHL_EXPRESS_WORLDWIDE: 'DHL Express Worldwide',
    DHL_EXPRESS_WORLDWIDE_EXPORT: 'DHL 环球快递出口',
    DHL_EXPRESS_WORLDWIDE_IMPORT: 'DHL 环球快递进口',
    DHL_EXPRESS_WORLDWIDE_THIRD_COUNTRY: 'DHL 环球快递三方',
    standard: '标快',
    economy: '经济',
    priority_freight: '优先货运',
    economy_freight: '经济货运',
    deferred_freight: '递延货运'
  },

  // 航空公司重量段配置
  weightTier: {
    title: '重量段配置 - {name}',
    batchTitle: '批量设置重量段',
    batchTip: '选择模板后可调整重量段明细，保存时将为 {count} 个航空公司统一设置',
    add: '添加重量段',
    batchAdd: '批量添加',
    loadTemplate: '从默认模板加载',
    name: '重量段名称',
    namePlaceholder: '如：0-45kg、1000kg+',
    startWeight: '起始重量(kg)',
    endWeight: '结束重量(kg)',
    unlimited: '无上限',
    range: '重量区间说明',
    step: '递增步长(kg)',
    count: '递增次数',
    templateCount: '包含 {count} 个重量段',
    templateRequired: '请选择重量段模板',
    saveSuccess: '重量段配置保存成功',
    batchSaveSuccess: '批量重量段配置保存成功',
    emptyError: '重量段列表不能为空',
    nameRequired: '重量段名称不能为空',
    startRequired: '起始重量不能为空',
    firstStartRequired: '第一行起始重量必须为0，空运重货模板可从100开始',
    endGreaterThanStart: '结束重量必须大于起始重量',
    unlimitedLast: '无上限重量段必须放在最后一行',
    continuityError: '重量段必须连续'
  },

  // 航空公司密度等级配置
  densityGrade: {
    title: '密度等级配置 - {name}',
    batchTitle: '批量设置密度等级',
    batchTip: '将使用已配置的密度等级为 {count} 个航空公司统一设置',
    add: '添加密度等级',
    minRatio: '起始密度(kg/CBM)',
    maxRatio: '结束密度(kg/CBM)',
    unlimited: '无上限',
    range: '密度范围',
    description: '说明',
    descriptionPlaceholder: '请输入说明',
    emptyText: '暂无密度等级配置，请点击“添加密度等级”开始配置',
    saveSuccess: '密度等级配置保存成功',
    batchSaveSuccess: '批量密度等级配置保存成功',
    emptyError: '密度等级列表不能为空',
    minRequired: '起始密度不能为空',
    firstMinRequired: '第一行起始密度必须为0',
    maxGreaterThanMin: '结束密度必须大于起始密度',
    unlimitedLast: '无上限密度等级必须放在最后一行',
    continuityError: '密度等级必须连续'
  },

  // 船公司表格列
  shippingTable: {
    nameCn: '船公司名称（中文）',
    nameEn: '船公司名称（英文）',
    shortName: '简称',
    carrierCode: '船公司代码',
    scacCode: 'SCAC CODE',
    eoriNumber: 'EORI Number',
    code9000: '9000 CODE',
    naccsCode: 'NACCS CODE',
    ediCodes: 'EDI代码',
    status: '状态',
    operation: '操作',
    codesCount: '{count} 个代码',
    notSet: '未设置'
  },

  // 航空公司表格列
  airlineTable: {
    nameCn: '航空公司名称（中文）',
    nameEn: '航空公司名称（英文）',
    nameCnAliases: '中文别名',
    nameEnAliases: '英文别名',
    shortName: '简称',
    carrierCode: '航空公司代码',
    iataCode: 'IATA二字码',
    awbPrefix: 'IATA三字码',
    icaoCode: 'ICAO三字码',
    prefix: 'PREFIX',
    contact: '联系人',
    phone: '联系电话',
    status: '状态',
    operation: '操作'
  },

  // 铁路公司表格列
  railwayTable: {
    nameCn: '铁路公司名称（中文）',
    nameEn: '铁路公司名称（英文）',
    shortName: '简称',
    carrierCode: '铁路公司代码',
    logo: 'Logo',
    country: '国家',
    province: '省/州',
    status: '状态',
    operation: '操作'
  },

  // 快递运营商表格列
  expressTable: {
    nameCn: '运营商名称（中文）',
    nameEn: '运营商名称（英文）',
    carrierCode: '运营商编码',
    accountNos: '客户账号',
    serviceTypes: '服务类型',
    remark: '备注',
    status: '状态',
    operation: '操作'
  },

  // 平台新增弹窗
  associateModal: {
    shippingTitle: '新增船公司',
    airlineTitle: '新增航空公司',
    railwayTitle: '新增铁路公司',
    expressTitle: '新增快递运营商',
    confirmText: '确认新增 ({count})',
    selected: '已选择 {count} 个{type}，共 {total} 个可选',
    shippingType: '船公司',
    airlineType: '航空公司',
    railwayType: '铁路公司',
    expressType: '快递运营商'
  },

  // EDI设置弹窗
  ediModal: {
    title: 'EDI代码设置',
    platform: '平台',
    ediCode: 'EDI代码',
    addCode: '添加EDI代码',
    deleteCode: '删除',
    saveButton: '保存',
    cancelButton: '取消',
    duplicateWarning: '平台重复',
    duplicateRowsError: '第 {rows} 行存在重复的平台',
    duplicateRowsSaveError: '第 {rows} 行存在重复的平台，请修改后再保存'
  },

  // 确认对话框
  confirm: {
    enableShipping: '确定要启用此船公司吗？',
    disableShipping: '确定要禁用此船公司吗？',
    enableAirline: '确定要启用此航空公司吗？',
    disableAirline: '确定要禁用此航空公司吗？',
    enableRailway: '确定要启用此铁路公司吗？',
    disableRailway: '确定要禁用此铁路公司吗？',
    enableExpress: '确定要启用此快递运营商吗？',
    disableExpress: '确定要禁用此快递运营商吗？',
    deleteEdiCode: '确定要删除此EDI代码吗？'
  },

  // 表单验证
  validation: {
    platformRequired: '请选择要新增的{type}',
    ediCodeRequired: 'EDI代码不能为空',
    platformRequired2: '平台不能为空'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的{type}',
    selectToDisable: '请选择要禁用的{type}',
    selectToAssociate: '请选择要新增的{type}',
    selectAirlineToConfig: '请选择要配置的航空公司',
    selectExpressToConfig: '请选择要配置的快递运营商',
    loadError: '{type}数据加载失败，请稍后重试',
    platformLoadError: '平台数据加载失败，请稍后重试',
    associateError: '新增{type}失败，请稍后重试',
    associateSuccess: '成功新增 {count} 个{type}',
    statusToggleError: '状态切换失败，请稍后重试',
    statusToggleSuccess: '{type}已{status}',
    batchEnableError: '批量启用失败，请稍后重试',
    batchEnableSuccess: '已启用 {count} 个{type}',
    batchDisableError: '批量禁用失败，请稍后重试',
    batchDisableSuccess: '已禁用 {count} 个{type}',
    ediSaveError: 'EDI代码保存失败，请稍后重试',
    ediSaveSuccess: 'EDI代码保存成功',
    ediDeleteError: 'EDI代码删除失败，请稍后重试',
    ediDeleteSuccess: 'EDI代码删除成功'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  }
}
